"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const invariant = function (condition, format, ...args) {
    var _a, _b;
    if (((_b = (_a = window === null || window === void 0 ? void 0 : window.process) === null || _a === void 0 ? void 0 : _a.env) === null || _b === void 0 ? void 0 : _b.NODE_ENV) !== 'production') {
        if (format === undefined) {
            throw new Error('invariant requires an error message argument');
        }
    }
    if (!condition) {
        let error;
        if (format === undefined) {
            error = new Error('Minified exception occurred; use the non-minified dev environment ' +
                'for the full error message and additional helpful warnings.');
        }
        else {
            let argIndex = 0;
            error = new Error(format.replace(/%s/g, () => {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1;
        throw error;
    }
};
exports.default = invariant;
//# sourceMappingURL=invariant.js.map